import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from "../restricted-account-object/restricted-account-object.model";

export interface ITransitionArgs extends IRestrictedAccountObjectArgs {
    title?: string;
    fromStatuses?: Array<string>;
    jobStatus?: string;
    notificationTemplates?: Array<string>;
    defaultTasks?: Array<string>;
}

const defaults = () => ({
    title: "",
    fromStatuses: [],
    jobStatus: "",
    notificationTemplates: [],
    defaultTasks: []
});

export class Transition extends RestrictedAccountObject {
    title: string;
    fromStatuses: Array<string>;
    jobStatus: string;
    notificationTemplates: Array<string>;
    defaultTasks: Array<string>;

    constructor(data?: ITransitionArgs) {
        super({...defaults(), ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.model.ts